(() => {
  if (window.pfBundleSubtitles) return;
  window.pfBundleSubtitles = true;
  const selector = '.kaching-bundles__mix-and-match-product__title';
  const singleSelector = '.kaching-bundles__bar-collection-products .kaching-bundles__collection-product__title';
  const watchSelector = selector + ', ' + singleSelector + ', .kaching-bundles__bar-subtitle';
  const pattern = /^(.+?)\s+[-–—]\s+((?:inspired\s+by|ge[iï]nspireerd\s+op)\s+.+)$/i;
  let scheduled = false;
  const update = () => {
    scheduled = false;
    document.querySelectorAll(singleSelector).forEach(title => {
      const bar = title.closest('.kaching-bundles__bar-wrapper');
      const subtitle = bar?.querySelector('.kaching-bundles__bar-subtitle')?.textContent.trim() || '';
      const single = bar?.querySelectorAll('.kaching-bundles__collection-product__title').length === 1;
      if (single && /^(?:inspired\s+by|ge[iï]nspireerd\s+op)\s+\S/i.test(subtitle)) {
        title.dataset.pfSingleSubtitle = subtitle;
      } else {
        delete title.dataset.pfSingleSubtitle;
      }
    });
    document.querySelectorAll(selector).forEach(title => {
      const match = title.textContent.trim().match(pattern);
      if (match) {
        title.dataset.pfBundleName = match[1].trim();
        title.dataset.pfBundleSubtitle = match[2].trim();
      } else {
        delete title.dataset.pfBundleName;
        delete title.dataset.pfBundleSubtitle;
      }
    });
  };
  const schedule = () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
  };
  // Keep Kaching's own text nodes and handlers intact. Only presentation attributes change.
  new MutationObserver(records => {
    if (records.some(record => {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (target?.closest(watchSelector)) return true;
      return Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (node.matches(watchSelector) || node.querySelector(watchSelector)));
    })) schedule();
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  update();
})();